import styled from '@app/styled';

export const Center = styled.div`
    text-align: center;
    width: 100%;
`;

export const InputWrapper = styled.div`
    width: 135px;
    margin: 0 auto;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin: 30px auto;
    div:first-child {
        margin-right: 10px;
    }
`;
